import { QuestPage } from "../../view/quest/QuestPageView";
import { COMPONENTS, EVENTS } from "../../lib/constants";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import HELPERS from "../../lib/globals/helpers/Helpers";
import { QuestPageMobile } from "../../view/quest/QuestPageMobileView";
import { Easing, Tween } from "@tweenjs/tween.js";
import { NotificationView } from "../../view/notifications/NotificationView";
import Light from "./helper/light";
import { isDesktop } from "react-device-detect";

const events = [
  EVENTS.MODAL,
  EVENTS.ERROR_PAGE,
  EVENTS.SETTINGS_UPDATE,
  EVENTS.QUEST_CAN_CLAIM,
];

class QuestWidgetController {
  constructor(viewController, config) {
    this.vc = viewController;
    this.config = config;
    this.isEnabled = false;
    this.prevProgress = 0;
    this.vc.getChildByName("FTR_QUEST_TIMER", true).text = "00:00:00";
    this.bookTween = null;
    this.book = this.vc.getChildByName("fg", true);
    this.modalItem = this.vc.getChildByName(this.config.modal);
    if (!this.modalItem) {
      throw new Error(
        `QuestWidgetController failed to initialize: ${JSON.stringify(this.config)}`
      );
    }
    this.item = this.modalItem;
    this.item.alpha = 0;
    this.item.interactive = false;
    this.item.cursor = "default";
    this.notify = this.vc.ui_ftr_quest.quest_notify;
    this.vc.getChildByName("quest_widget_bg", true).cursor = "default";
    this.initLight();
    this.initializeWidget();
    if (GameConfigs.quest_parsed) {
      if (this.prevProgress !== GameConfigs.quest_parsed.total_progress) {
        this.showLights(GameConfigs.quest_parsed.total_progress);
        this.prevProgress = GameConfigs.quest_parsed.total_progress;
      }
    }
  }

  initLight() {
    this.light_1 = new Light(this.vc, isDesktop ? 78 : 90, isDesktop ? 55 : 65);
    this.light_2 = new Light(this.vc, isDesktop ? 80 : 92, isDesktop ? 40 : 50);
    this.light_3 = new Light(this.vc, isDesktop ? 80 : 92, isDesktop ? 26 : 36);
    this.light_4 = new Light(this.vc, isDesktop ? 82 : 94, isDesktop ? 10 : 20);
    this.lightAlpha(0);
  }

  lightAlpha(alpha) {
    this.light_1.alpha = alpha;
    this.light_2.alpha = alpha;
    this.light_3.alpha = alpha;
    this.light_4.alpha = alpha;
  }
  stopAndResetTween(tween, object) {
    if (tween) {
      tween.stop();
      object.scale.set(1);
      return null;
    }
    return tween;
  }

  resetLightScale() {
    this.light_1_tween = this.stopAndResetTween(
      this.light_1_tween,
      this.light_1
    );
    this.light_2_tween = this.stopAndResetTween(
      this.light_2_tween,
      this.light_2
    );
    this.light_3_tween = this.stopAndResetTween(
      this.light_3_tween,
      this.light_3
    );
    this.light_4_tween = this.stopAndResetTween(
      this.light_4_tween,
      this.light_4
    );
    this.bookTween = this.stopAndResetTween(this.bookTween, this.book);
  }

  showLights(num) {
	window.sm.play({ name: 'quest_complete_sfx' });
	const setLightAlpha = (count) => {
	  for (let i = 1; i <= count; i++) {
		this[`light_${i}`].alpha = 1;
	  }
	};
	const createTween = (object, scale, repeat, onComplete) => {
	  return new Tween(object.scale)
		.to(scale, 500)
		.yoyo(true)
		.repeat(repeat)
		.easing(Easing.Linear.None)
		.onComplete(() => {
		  object.scale.set(1);
		  if (onComplete) onComplete();
		})
		.start();
	};
	const resetTweens = (count) => {
	  for (let i = 1; i <= count; i++) {
		this[`light_${i}_tween`] = createTween(this[`light_${i}`], { x: 1.2, y: 1.2 }, 5, () => {
		  this[`light_${i}_tween`] = null;
		});
	  }
	};
	this.resetLightScale();
	switch (num) {
	  case 1:
		setLightAlpha(1);
		this.bookTween = createTween(this.vc.getChildByName('fg', true), { x: 1.05, y: 1.05 }, 5, () => {
		  this.bookTween = null;
		});
		resetTweens(1);
		break;
	  case 2:
		setLightAlpha(2);
		this.bookTween = createTween(this.vc.getChildByName('fg', true), { x: 1.05, y: 1.05 }, 5, () => {
		  this.bookTween = null;
		});
		resetTweens(2);
		break;
	  case 3:
		setLightAlpha(3);
		this.bookTween = createTween(this.vc.getChildByName('fg', true), { x: 1.05, y: 1.05 }, 5, () => {
		  this.bookTween = null;
		});
		resetTweens(3);
		break;
	  case 4:
		setLightAlpha(4);
		this.bookTween = createTween(this.vc.getChildByName('fg', true), { x: 1.05, y: 1.05 }, Infinity);
		for (let i = 1; i <= 4; i++) {
		  this[`light_${i}_tween`] = createTween(this[`light_${i}`], { x: 1.2, y: 1.2 }, Infinity);
		}
		break;
	  default:
		break;
	}
  }
  

  showWidget() {
    this.item.interactive = true;
    this.item.alpha = 1;
    this.vc.alpha = 1;
    this.item.cursor = "pointer";
    this.vc.ui_ftr_quest.quest_widget_bg.cursor = "pointer";
  }

  initializeWidget() {
    this.item.alpha = 0;
    this.item.interactive = false;
    this.item.handler = this.handleItemClick.bind(this);
    this.vc.ui_ftr_quest.quest_widget_bg.cursor = "default";

    const secondsLeft = parseInt(GameConfigs.quest.seconds_left, 10);
    GameConfigs.time_left = secondsLeft;
    window.addEventListener(EVENTS.QUEST_END, this, false);
    window.addEventListener(EVENTS.QUEST_UPDATE, this, false);
    window.addEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
    if (GameConfigs.config.hasbonus) {
      this.item.interactive = false;
      this.vc.ui_ftr_quest.quest_widget_bg.cursor = "default";
    }
    if (GameConfigs.config.hasquest) {
      this.showWidget();
      this.registerEvents();
      window.addEventListener(EVENTS.BONUS_BUY, this, false);
    }
  }

  registerEvents() {
    events.forEach((event) => window.addEventListener(event, this));
    if (
      GameConfigs.settings.keyboard_shortcuts &&
      !window.isMobile &&
      !window.isTablet
    ) {
      this.isEnabled = true;
      window.addEventListener("keydown", this);
    }
  }

  handleEvent(event) {
    switch (event.type) {
      case EVENTS.ERROR_PAGE:
        this.removeEvents();
        window.removeEventListener(EVENTS.QUEST_UPDATE, this, false);
        window.removeEventListener(EVENTS.QUEST_END, this, false);
        window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
        window.removeEventListener(EVENTS.BONUS_BUY, this, false);
        this.resetLightScale();
        break;
      case EVENTS.BONUS_BUY:
        if (event.detail.bonus) {
          this.removeEvents();
          this.resetLightScale();
        } else {
          this.item.interactive = true;
          this.item.getChildByName("quest_widget_bg", true).cursor = "pointer";
          this.registerEvents();
        }
        break;
      case "keydown":
        if (GameConfigs.disabled.quest_widget) return;
        if (event.keyCode === 81) this.handleItemClick();
        break;
      case EVENTS.SETTINGS_UPDATE:
        this.updateKeyboardShortcutsSetting(event);
        break;
      case EVENTS.MODAL:
        this.updateModalInteractivity(event);
        break;
      case EVENTS.QUEST_CAN_CLAIM:
        if (this.prevProgress !== event.detail.total_progress) {
          this.showLights(event.detail.total_progress);
          this.prevProgress = event.detail.total_progress;
        }
        break;
      case EVENTS.QUEST_UPDATE:
        this.vc.getChildByName("FTR_QUEST_TIMER", true).text =
          event.detail.formated;
        break;
      case EVENTS.BONUS_ROUND_STATE:
        if (event.detail.state === "started") {
          window.removeEventListener(EVENTS.QUEST_UPDATE, this, false);
          window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
          window.removeEventListener(EVENTS.BONUS_BUY, this, false);
        }
        break;
      case EVENTS.QUEST_END:
        if (event.detail.end) {
          this.lightAlpha(0);
          this.resetLightScale();
          HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
            quest_claim: {
              ...GameConfigs.quest_claim,
              claimed: true,
              activated: false,
              activated_item: 0,
              bet_level: GameConfigs.quest.bet_level,
              item: null,
              step: false,
              status: "",
            },
          });
          GameConfigs.quest_is_active = false;
          GameConfigs.quest_claim = {
            ...GameConfigs.quest_claim,
            claimed: true,
            activated: false,
            activated_item: 0,
            bet_level: GameConfigs.quest.bet_level,
            item: null,
            step: false,
            status: "",
          };
          GameConfigs.quest_current = null;

          if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
            GameConfigs.uiComponent.removeView(
              GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
            );
            if (GameConfigs.modal !== "notification") {
              GameConfigs.modal = "notification";
              GameConfigs.notification = {
                code: 1112,
                title: "",
                desc: "",
              };
              HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
                modal: "notification",
              });
              HELPERS.dispatchCustomEvent(EVENTS.NOTIFICATION, {
                notification: true,
              });
              GameConfigs.uiComponent.addView(NotificationView);
            }
          }
        }
        break;
      default:
        break;
    }
  }

  updateKeyboardShortcutsSetting(event) {
    if (window.isMobile || window.isTablet) return;
    const { keyboard_shortcuts } = event.detail.data;
    if (keyboard_shortcuts === undefined) return;

    this.isEnabled = keyboard_shortcuts;
    if (keyboard_shortcuts) {
      window.addEventListener("keydown", this, false);
    } else {
      window.removeEventListener("keydown", this, false);
    }
  }

  updateModalInteractivity(event) {
    const modalTypes = ["settings", "quest", "quest_claim"];
    const shouldDisable =
      (modalTypes.includes(event.detail.modal) &&
        (window.isMobile || window.isTablet)) ||
      GameConfigs.bonusBuy;
    this.item.interactive = !shouldDisable;
  }

  handleItemClick() {
    if (
      GameConfigs.disabled.quest_widget ||
      GameConfigs.isFreeSpin ||
      GameConfigs.autospin.isAutoOn ||
      GameConfigs.reelComponent.rotating
    ) {
      this.animateDisable();
      return;
    }
    window.sm.play({ name: "item_click_sfx" });
    const isQuestModal =
      GameConfigs.modal === "quest" || GameConfigs.modal === "quest_claim";
    if (isQuestModal) {
      const uiComponentKey =
        GameConfigs.modal === "quest"
          ? this.config.items[0]
          : this.config.items[1];
      GameConfigs.uiComponent[uiComponentKey].CloseController.closeHandler();
      this.dispatchCustomEvent("");
    } else {
      this.processQuestModalAction();
    }
  }

  processQuestModalAction() {
    const modalAction =
      GameConfigs.quest.status === "completed" ? "quest_claim" : "quest";
    this.dispatchCustomEvent(modalAction);

    const uiComponent = GameConfigs.uiComponent;
    const viewToAdd = window.isMobile ? QuestPageMobile : QuestPage;
    const uiComponentKey =
      modalAction === "quest" ? this.config.items[0] : this.config.items[1];

    if (modalAction === "quest") {
      uiComponent.addView(viewToAdd);
    }

    uiComponent[uiComponentKey].CloseController.onClose(() => {});
  }
  dispatchCustomEvent(modal) {
    HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal });
  }

  removeEvents() {
    this.item.interactive = false;
    this.item.getChildByName("quest_widget_bg", true).cursor = "default";
    events.forEach((event) => window.removeEventListener(event, this, false));
    window.removeEventListener("keydown", this, false);
    // window.removeEventListener(EVENTS.BONUS_BUY, this, false);
  }

  animateDisable() {
    window.sm.play({ name: "error_sfx" });
    new Tween(this.item)
      .to({ x: +5 }, 10)
      .yoyo(true)
      .repeat(5)
      .easing(Easing.Linear.None)
      .start();
  }
}

export default QuestWidgetController;